import { render, staticRenderFns } from "./UpgradeToPro.vue?vue&type=template&id=60a0fcba&scoped=true"
import script from "./UpgradeToPro.vue?vue&type=script&lang=js"
export * from "./UpgradeToPro.vue?vue&type=script&lang=js"
import style0 from "./UpgradeToPro.vue?vue&type=style&index=0&id=60a0fcba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0fcba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
